const LocalStorage = {
  ANONYMOUS_ID: 'anonymousId',
  FEATURES: 'features',
} as const;

export { LocalStorage };
